import * as React from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import Icn from './Icn';
import IconBtn from './IconBtn';
import { colors } from '../maps/colors';
import PlaySiteDialog from "./dialogs/PlaySiteDialog";
import { addOrDeleteQueryParams, getQueryValue } from "../domain/queryHandler";
import { api } from '../maps/data.js';
import { Button } from '@mui/material';
import QRCode from "react-qr-code";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Tx from './Tx';

function InstallerSiteCard(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const [isRecording, setIsRecording] = useState(!!props.isRecording);
    const [openQR, s_openQR] = useState(false);

    const changeUrl = (query) => {
        navigate({
            search: query
        });
    }

    const setDebugMode = async () => {
        await api({
            'type': 'setSiteDebugMode', 'data': {
                siteId: props._id,
                enabled: !props.isDebug
            },
        });
        props.forceSiteUpdate();
    }

    const restartSite = async () => {
        await api({
            type: 'restartSite',
            data: {
                siteId: props._id
            }
        });
    };

    const toggleRecording = async () => {
        await api({
            type: 'editSite',
            data: {
                _id: props._id,
                name: props.name,
                isRecording: !isRecording
            }
        });

        await api({
            type: 'setSiteIsRecording',
            data: {
                siteId: props._id,
                isRecording: !isRecording
            },
        });

        setIsRecording(!isRecording);
    }

    const isPlayGroundDialogOpen = getQueryValue(location, 'playSiteDialog') === props._id;

    return (
        <Card data-id={props._id} onClick={props.onClick} sx={{ width: '100%', marginBottom: '5px', background: props.selected ? colors.LIGHT_GREEN + "50" : 'white' }}>
            <div style={{padding: 5}}>
                <Icn style={{position: 'relative', top: 4}}>store</Icn> <span
                style={{fontSize: 18, fontWeight: 500}}>{props.name}</span>
                <div style={{fontSize: 12}}>
                    SMU IP: {props.smuIp}
                </div>

            </div>
            <div style={{padding: 5}}>
                <IconBtn customtheme="small-gray" size="small" onClick={props.onEdit}>edit</IconBtn>
                <IconBtn customtheme="small-gray" size="small" style={{ marginLeft: 5 }}>delete</IconBtn>
                <IconBtn customtheme="small-gray" size="small" style={{ marginLeft: 5, color: colors.GREEN }}
                    onClick={(e) => {
                        e.stopPropagation();
                        const urlToPush = addOrDeleteQueryParams(location, [{ playSiteDialog: props._id }]);
                        changeUrl(urlToPush);
                    }}>play</IconBtn>
                {/*<Button onClick={(e) => { e.stopPropagation(); toggleRecording(); }} variant='outlined'>{isRecording ? 'STOP REC' : 'START REC'}</Button>*/}

                {isPlayGroundDialogOpen && (
                    <PlaySiteDialog
                        onClose={(e) => {
                            e.stopPropagation();
                            const urlToPush = addOrDeleteQueryParams(location, [{ playSiteDialog: null }]);
                            changeUrl(urlToPush);
                        }}
                        siteId={props._id}
                        siteName={props.name}
                    />
                )}

                <IconBtn
                    title="Debug mode"
                    customtheme="small-gray" size="small"
                    style={{ marginLeft: 5, color: props.isDebug ? colors.RED1 : colors.GREEN }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setDebugMode();
                    }}
                >
                    bugReportIcon
                </IconBtn>
                <IconBtn
                    onClick={(e) => {
                        e.stopPropagation();
                        restartSite();
                    }}
                    customtheme="small-gray" size="small" style={{ marginLeft: 5, color: colors.TEAL }}>
                    restartAltIcon
                </IconBtn>
                {
                    props._id && <IconButton size={"normal"} onClick={() => s_openQR(true)}>
                        <QRCode value="zibi" size={18} />
                    </IconButton>
                }
            </div>
            {
                openQR && <Dialog fullScreen open={true}>
                    <DialogContent style={{ textAlign: 'center' }}>
                        <div style={{ marginTop: 100, marginBottom: 30 }}>QR CODE</div>
                        <QRCode value={`{"siteId": "${props._id}"}`} size={256} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => s_openQR(false)}><Tx>g.close</Tx></Button>
                    </DialogActions>
                </Dialog>
            }
        </Card>
    );
}

export default InstallerSiteCard;